import { gematriya } from '@hebcal/core';

/** 5787 → "תשפ״ז" */
export function gematriyaYear(y: number): string {
  return gematriya(y % 1000);
}
